import { render, staticRenderFns } from "./zhiyuan.vue?vue&type=template&id=626cae17&scoped=true"
import script from "./zhiyuan.vue?vue&type=script&lang=js"
export * from "./zhiyuan.vue?vue&type=script&lang=js"
import style0 from "./zhiyuan.vue?vue&type=style&index=0&id=626cae17&prod&scoped=true&lang=css"
import style1 from "./zhiyuan.vue?vue&type=style&index=1&id=626cae17&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626cae17",
  null
  
)

export default component.exports